<ui-alert variant="info">
    Selecione {{ field.tipo === 'listaFixa' ? 'uma opção' : 'uma ou mais opções' }}!
</ui-alert>

<ui-card
    variant="internal"
    shape="square"
    display="full-space"
>
    <table ui-table>
        <tbody>
            @for (item of field.itens; track item; let i = $index) {
                @let _wasSelected = wasSelected (item);
                @let _hasCondicional = hasConditional (item);
                @let _isInconsistency = isInconsistency (item);

                @let _letHighlight = _isInconsistency || _wasSelected || _hasCondicional;

                <tr ui-table-row
                    [highlight]="_letHighlight"
                    [highlightColor]="getHighlightColor(_wasSelected, _isInconsistency, _hasCondicional)"
                    (click)="selectItem(item)"
                    class="cursor-pointer"
                >
                    <td class="col-1">
                        <ui-switch
                            [checked]="_wasSelected"
                            [disableToggle]="true"
                        ></ui-switch>
                    </td>
                    <td
                        class="col-10"
                    >
                        {{ item }}
                    </td>

                    <td class="col-1">
                        @if (hasTriggeredConditional (item)) {
                            <ui-button
                                variant="outline"
                                color="secondary"
                                (click)="$event.stopPropagation(); showConditionalGroup(item)"
                            >
                                <i class="fa fa-edit"></i>
                            </ui-button>
                        }
                    </td>
                </tr>
            }
        </tbody>
    </table>
</ui-card>

@if (validateConditional ()) {
    <app-material-input
        label="Justifique"
        [required]="true"
    >
        <textarea [(ngModel)]="data.outro_valor">
        </textarea>
    </app-material-input>
}

